<div class="overlap_panel_wrapper">
  <div class="overlap_panel_sidebar">
    <div class="side_header">
      <div class="cross_wrap">
        <a href="javascript:void(0);" (click)="close('')">
          <img src="../../../../assets/img/cross_icon.svg" alt="" class="icon">
        </a>
      </div>
      <p class="company_name">Change Order</p>
      <div class="back_wrap">
        @if (stepper.selectedIndex > 0) {
          <a (click)="helperService.stepperGoBack(stepper)" class="back-button">
            <img src="../../../../assets/img/left_orange_arrow.svg" alt="Back" class="arrow">
            <span>Back</span>
          </a>
        }
      </div>
    </div>
    <div class="sidebar_accordion">
      @if (addChangeOrderForm?.get('step01')?.get('changeOrder')) {
        <app-change-order-step-preview  [form]="addChangeOrderForm" [model]="model" [step]="step" ></app-change-order-step-preview>
      }
      <!--      <app-ticket-step-preview [model]="model" [step]="step" [form]="ticketForm"></app-ticket-step-preview>-->
    </div>
  </div>

  <div class="overlap_right_panel">
    <form [formGroup]="addChangeOrderForm"    novalidate>
      <mat-horizontal-stepper #stepper [linear]="true" (selectionChange)="onStepChanged($event, stepper)">
        <mat-step formGroupName="step01"   [stepControl]="addChangeOrderForm.get('step01')!">
          <ng-template matStepLabel>Add Change Order</ng-template>
          <!--          <app-ticket-detail formControlName="ticketDetail" [form]="ticketForm" [model]="model" [isEdit]="isEdit" (onInitForm)="initChildForm('step01', 'ticketDetail',$event.value)" ></app-ticket-detail>-->
          <app-add-change-order formControlName="changeOrder"  [form]="addChangeOrderForm.get('step01')" [model]="model" (onInitForm)="initChildForm('step01', 'changeOrder',$event.value)" ></app-add-change-order>
          <div class="controls">
            <button mat-button class="btn_transparent" (click)="close('')">Cancel</button>
            <button type="button" mat-button matStepperNext (click)="touchFormControls('step01')" class="btn_solid_color">Next  <img src="../../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>

        </mat-step>

        <mat-step formGroupName="step02"   [stepControl]="addChangeOrderForm.get('step02')!">
          <ng-template matStepLabel>Drawing</ng-template>
          <app-drawing formControlName="drawingForm" [form]="addChangeOrderForm.get('step02')" [model]="model" (onInitForm)="initChildForm('step02', 'changeOrder',$event.value)"></app-drawing>
          <!--          <app-ticket-information formControlName="ticketInfo" [form]="ticketForm" [model]="model" [isEdit]="isEdit" (onInitForm)="initChildForm('step02', 'ticketInfo',$event.value)" ></app-ticket-information>-->

          <div class="controls">
            <button mat-button matStepperPrevious class="btn_transparent">Back</button>
            <!--            <button mat-button class="btn_transparent" (click)="close('')">Cancel</button>-->
            <button type="button" mat-button matStepperNext (click)="finalPreviewFn(stepper)" class="btn_solid_color">Review  <img src="../../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>

          </div>

        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Preview</ng-template>
          @if (this.step?.event?.selectedIndex === 2) {
            <app-change-order-preview [model]="model"  [form]="addChangeOrderForm"></app-change-order-preview>
          }
          <!--          <app-note-preview [model]="model"  *ngIf="this.step?.event?.selectedIndex === 2" [form]="noteForm"></app-note-preview>-->
          <div class="controls">
            <button mat-button matStepperPrevious (click)="cancelPreview()" class="btn_transparent">Back</button>
            <button type="button" mat-button  class="btn_solid_color" (click)="onSubmit()">{{id ? 'Update' : 'Create'}}  <img src="../../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>

        </mat-step>

      </mat-horizontal-stepper>
    </form>

  </div>
</div>
